const position = {
  singleDeletion: {
    title: 'Please confirm that you understand what will happen by deleting this position:',
    conditions: [
      'Position will be deleted',
      'All shifts, tasks, pages and conversations created for this position will be deleted',
    ],
    confirmText: 'DELETE POSITION',
  },
  multipleDeletion: {
    title: 'Please confirm that you understand what will happen by deleting selected positions:',
    conditions: [
      'Selected positions will be deleted',
      'All shifts, tasks, pages and conversations created for these positions will be deleted',
    ],
    confirmText: 'DELETE POSITIONS',
  },
  multipleUnarchive: {
    title: 'Please confirm that you want to unarchive these positions',
  },
};

const location = {
  singleDeletion: {
    title: 'Please confirm that you understand what will happen by deleting this location:',
    conditions: [
      'Location will be deleted',
      'All shifts, tasks, pages and conversations created for this location will be deleted',
    ],
    confirmText: 'DELETE LOCATION',
  },
  multipleDeletion: {
    title: 'Please confirm that you understand what will happen by deleting selected locations:',
    conditions: [
      'Selected locations will be deleted',
      'All shifts, tasks, pages and conversations created for these locations will be deleted',
    ],
    confirmText: 'DELETE LOCATIONS',
  },
  multipleUnarchive: {
    title: 'Please confirm that you want to unarchive these locations',
  },
};

export const groupTexts = {
  defaultText: 'Please confirm that you understand what will happen by deleting this',
  group: {
    singleDeletion: {
      title: 'Please confirm that you understand what will happen by deleting this group:',
      conditions: [
        'Group will be deleted',
        'All tasks, pages or conversations created for this group will be deleted',
      ],
    },
    multipleDeletion: {
      title: 'Please confirm that you understand what will happen by deleting selected groups:',
      conditions: [
        'Selected groups will be deleted',
        'All tasks, pages or conversations created for these groups will be deleted',
      ],
    },
  },
  position,
  location,
  archivedLocation: {
    unarchive: {
      title: 'Please confirm that you want to unarchive this location',
    },
    ...location,
  },
  archivedPosition: {
    unarchive: {
      title: 'Please confirm that you want to unarchive this position',
    },
    ...position,
  },
  tag: {
    singleDeletion: {
      title: 'Please confirm that you understand what will happen by deleting this tag:',
      conditions: ['Tag will be deleted from all applicable shifts'],
    },
    multipleDeletion: {
      title: 'Please confirm that you understand what will happen by deleting selected tag:',
      conditions: ['Selected tags will be deleted from all applicable shifts'],
    },
  },
};
